import { Modal } from "src/context/modal/Modal"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { WhatsNewModalContent } from "./WhatsNewModalContent"
import type { SupportedLanguage } from "./whatsNew.messages"
import { whatsNewMessages } from "./whatsNew.messages"

type WhatsNewModalProps = ModalProps<{
	language: SupportedLanguage
	onDismiss: () => void
}>

export const WhatsNewModal = ({ id, modalProps: { language, onDismiss } }: WhatsNewModalProps) => {
	return (
		<Modal id={id} heading={whatsNewMessages[language].heading} width="auto" onDismiss={onDismiss}>
			<WhatsNewModalContent language={language} />
		</Modal>
	)
}
